export default __webpack_public_path__ + "static/media/zapf.6b8aa6ca.png";